/**
 *  Copyright AlpineReplay Inc, 2022. All rights reserved.
 *  Authors: Tabitha Bleil
 */

import React, { useState } from "react"
import {
    Label,
    TitleSection,
    ModalTitle,
    ContentSection,
    FooterSection,
    Column,
    Button,
    Row,
    Icon,
    Input,
    Color,
    isSmallMobileScreen,
} from "trux"
import { validatePhone } from "../../../util/helpers"

export const PlayerDetails = ({ loggedInUser, role, onBackClick, onDone }) => {
    const [name, setName] = useState("")
    const [email, setEmail] = useState(loggedInUser.email)
    const [number, setNumber] = useState("")
    const [errors, setErrors] = useState({
        name: null,
        email: null,
        phone: null,
        ready: true,
    })

    const validate = () => {
        var nameError = null

        var phoneError = null
        var ready = true

        if (name.length === 0 && role !== "self") {
            nameError = "You must enter a name to create your Trace account."
        }

        if (number.length !== 0 && !validatePhone(number)) {
            phoneError = "Invalid phone number"
        }

        if (nameError || phoneError) {
            ready = false
        }
        setErrors({
            name: nameError,
            phone: phoneError,
            ready: ready,
        })

        return ready
    }

    const onContinue = () => {
        if (validate()) {
            onDone({
                first_name: name,
                email: email,
                //phone: number,
                relation_type: "child",
            })
        }
    }
    return (
        <>
            <TitleSection onBackClick={onBackClick}>
                <ModalTitle content="Your details" />
            </TitleSection>
            <ContentSection>
                <Column center span="12" className="form">
                    <Input
                        type={Input.Type.Name}
                        label={
                            <Row>
                                <Label
                                    type={Label.Type.SmallBody}
                                    content="Full Name"
                                    marginRight="1"
                                />{" "}
                                <Label
                                    type={Label.Type.SmallBody}
                                    content="*"
                                    color={Color.Error}
                                />
                            </Row>
                        }
                        width="343px"
                        onChange={(e) => setName(e)}
                        value={role === "self" ? loggedInUser.first_name : name}
                        error={errors.name}
                    />
                    <Input
                        type={Input.Type.Email}
                        label={
                            <Row>
                                <Label
                                    type={Label.Type.SmallBody}
                                    content="Email"
                                    marginRight="1"
                                />{" "}
                                <Label
                                    type={Label.Type.SmallBody}
                                    content="*"
                                    color={Color.Error}
                                />
                            </Row>
                        }
                        value={email}
                        onChange={(e) => setEmail(e)}
                        width="343px"
                        error={errors.email}
                    />
                    <Input
                        type={Input.Type.Text}
                        label={
                            <Label
                                type={Label.Type.SmallBody}
                                content="Phone #"
                            />
                        }
                        width="343px"
                        marginBottom="7"
                        onChange={(e) => setNumber(e)}
                        value={number}
                        error={errors.phone}
                    />
                    {!isSmallMobileScreen() && (
                        <Button
                            type={Label.Type.Heading5}
                            onClick={onContinue}
                            span="12"
                            className="button"
                            content={
                                <Row>
                                    <Label
                                        type={Label.Type.InnerButton}
                                        content="Continue"
                                        marginRight="2"
                                    />{" "}
                                    <Icon
                                        size={16}
                                        type={Icon.Type.CheveronRight}
                                    />
                                </Row>
                            }
                        />
                    )}
                </Column>
            </ContentSection>
            {isSmallMobileScreen() && (
                <FooterSection>
                    <Button
                        type={Label.Type.Heading5}
                        onClick={onContinue}
                        span="12"
                        className="button"
                        content={
                            <Row>
                                <Label
                                    type={Label.Type.InnerButton}
                                    content="Continue"
                                    marginRight="2"
                                />{" "}
                                <Icon
                                    size={16}
                                    type={Icon.Type.CheveronRight}
                                />
                            </Row>
                        }
                    />
                </FooterSection>
            )}
        </>
    )
}
